<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">充值</a></li>
            </ul>
        </div>
        
        <div class="formbody">    
            <div class="jian">&nbsp;</div>
            <div class="welinfo">
                <span><img src="../../assets/images/dp.png" alt="提醒" /></span>
                <b>温馨提示：</b>
            </div>    
            <ul class="infolist">
                <li><span>1.充值前询问客服短信内容是否可以发再决定要不要充值</span></li> 
                <li><span>2.预付款属用户自愿存入，只能用于云客服平台内消费，不能退款</span></li> 
                <li><span><b class="ea2020">充值前请确认您已经理解并将遵守本系统的</b><a href="#">资费表/套餐最低消费规则、用户协议</a></span></li>
            </ul> 
            <div class="coupon-wrapper">
                <div class="style-four" v-for="item in couponList">
                    <div class="info-box">
                        <p class="nick">充值抵用券</p>
                        <div class="coupon-money">
                            <div class="lay of">￥{{item.couponMoney}}</div>
                            <div class="lay">
                                <p class="demand">满{{item.chargeMoney}}元可用</p>
                            </div>
                            <div class="lay">
                                <p class="demand2">到期:{{item.endTime}}</p>
                            </div>
                        </div>
                    </div>
                    <a href="#" @click="getCoupon(item.id)" class="get-btn">
                        <span class="coBlack">立即领取</span>
                    </a>
                </div> 
            </div> 

            <div id="usual1" class="usual">     
                <div class="itab">
                    <ul> 
                        <li><a href="#tab1" class="selected">支付宝充值</a></li> 
                    </ul>
                </div>     
  	            <div id="tab1" class="tabson">    
                    <ul class="forminfo">
                        <li v-if="chargeActivityState==1"><label></label><font style="font-size:20px;" color="red">二办最新充值送活动：单笔充值满{{minChargeMoney}}以上 比划账优惠加送{{addRate}}%,直接充值到短信账户</font></li>           
                        <li><label>订单号<b>*</b></label><input name="" v-model="bidKey" type="text" disabled="true" class="dfinput" value=""  style="width:518px;"/></li>
                        <li><label>充值门牌号<b>*</b></label><input name="" type="text" class="dfinput" disabled="true" value="" v-model="account"  style="width:518px;"/></li>
                        <li><label>现有总帐户金额<b>*</b></label><input name="" type="text" class="dfinput" disabled="true" v-model="money" value=""  style="width:468px;"/><i>元</i></li>
                        <li><label>充值金额<b>*</b></label><div class="vocation">
                        <el-select v-model="chargeMoney" @change="onSelectChange">
                            <el-option
                                v-for="item in chargeLineList"
                                :key="item.money"
                                :label="item.money"
                                :value="item.money">
                            </el-option>
                        </el-select>
                        </div>元
                        <b>*</b>
                        <!-- <input name="" type="text" class="dfinput" value="" v-model="_num"  style="width:30px;"/>倍 -->
                        <el-select style="width:60px;" v-model="num" @change="onSelectChange">
                            <el-option
                                v-for="item in numList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>倍
                        </li>                        
                        <li><label>备注说明</label><input name="" type="text"  class="dfinput" value=""  style="width:518px;"/><i><a href="/youhui" target="_blank"><b> 多充多划多送，详情！！！</b></a></i></li>
                        <li><label>抵用券</label>
                            <span class="lh33" v-if="userCouponList.length <= 0">对不起，您暂时没有抵用券！<b class="ea2020">注意：使用抵用券后无法再享用充值送抵用券活动</b></span> 
                            
                            <div v-else class="vocation">
                                <el-radio-group v-model="userCouponId" @change="onRadioChange">
                                    <!-- <el-radio label="0" key="0" border style="width:180px;">
                                        <label style="margin: -43px 0px 0px 10px;font-size: 14px;cursor: pointer;" @click="onRadioChange('0')">不使用抵用券</label>
                                    </el-radio> -->
                                    <el-radio v-bind:disabled="item.chargeMoney > chargeMoney*num" :label="item.id" border :key="item.id" v-for="item in userCouponList" style="width:210px;">
                                        <label v-if="item.chargeMoney > chargeMoney*num" style="margin: -43px 0px 0px 10px;color: #ea2020;font-size: 14px;">{{item.description}}</label>
                                        <label v-else style="margin: -43px 0px 0px 10px;color: #ea2020;font-size: 14px;cursor: pointer;" @click="onRadioChange(item.id, item.description)">{{item.description}}</label>
                                    </el-radio>
                                </el-radio-group>
                            </div>
                        </li>
                        <li><label>&nbsp;</label><input class="sure1" type="button" value="提交支付宝或网上银行支付" @click="paySubmit()">&nbsp;</li>
                    </ul>    
                </div>     
  	            <div id="tab2" class="tabson">    
                    <p class="lh33">
                    充值及发票<br/>
                    1）支持网银及支付宝在线充值<br/>
                    第一次充值金额100元起。可开票用户充值满1000元起寄送发票；1000元以下请自付快递费<br/>
                    <!-- 2）线下汇款（到账需客服确认1－2个工作日）<br/>
                    账号明细：<br/>
                    *支付宝 对公帐号：pay2@2office.cn （注意输入后会显示：杭州快鱼科技有限公司，以免误打）<br/>
                    ****对公户名: 杭州快鱼科技有限公司 帐号: 74818100386771 开户行: 杭州银行西城支行 <br/>
                    以上请注明充值用途（对应门牌号或400号码）<br/> -->
                    </p>    
                </div>
            </div>
    
            <div class="tip tip1 ">
                <div class="tiptop"><span>支付宝支付信息确认</span><a></a></div>   
                <ul class="forminfo">    
                    <li><label class="tdlast" >订单号：</label><span class="lh33">{{bidKey}}</span> </li>                    
                    <li><label class="tdlast" >充值门牌号：</label><span class="lh33">{{account}}</span></li>                    
                    <li><label class="tdlast" >现帐户总金额：</label><span class="lh33">{{money}}</span></li>                    
                    <li><label class="tdlast" >本次充值金额：</label><span class="lh33">{{chargeMoney}}*{{num}} - {{couponMoney}} = {{allMoney}} </span></li>                    
                    <li><label class="tdlast" >抵用券：</label>
                        <span class="lh33">{{description}}<b class="ea2020">注意：使用抵用券后无法再享用充值送抵用券活动</b></span>   </li>
                    <li><label>&nbsp;</label>
                        <a :href="payUrl"><img src="../../assets/images/alipay_bwrx.gif" ></a>
                    </li>
                </ul>        
            </div>

        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            account:'',
            money:0,
            chargeLineList:[],
            userCouponList:[],
            couponList:[],
            bidKey:'',
            chargeMoney:0,
            num:'1',
            userCouponId:0,
            description:'无抵用券！',
            couponMoney:0,
            allMoney:0,
            payUrl:'',
            chargeActivityState:0,
            minChargeMoney:0,
            addRate:0,
            invoicetype:0,
            numList:[{value:1,label:1},{value:2,label:2},{value:3,label:3},{value:4,label:4},{value:5,label:5},
                    {value:6,label:6},{value:7,label:7},{value:8,label:8},{value:9,label:9},{value:10,label:10}]
        }
    },
    mounted(){
      this.getData();      
    },
    computed:{
    //   _num: {
    //     set: function(value) {
    //         this.num = value;
    //     },
    //     get: function() {
    //         return this.num.replace(/[^0-9]+/g,'')
    //     }
    //   }
    },
    methods:{
      getData(){
        var that = this
        let param = {}
        this.$ajax({
            method: 'post',
            url: this.GLOBAL.serverSrc + "/person/pay.json",
            data: param,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'token' : this.GLOBAL.token
            }
        }).then(function(res) {
            if(res.data.code == '0000000')
            {
                that.account = res.data.account;
                that.money = res.data.money;
                that.bidKey = res.data.bidKey;
                that.chargeActivityState = res.data.chargeActivityState == undefined ? 0 : res.data.chargeActivityState;
                that.minChargeMoney = res.data.minChargeMoney == undefined ? 0 : res.data.minChargeMoney;
                that.addRate = res.data.addRate == undefined ? 0 : res.data.addRate;
                if(res.data.chargeLineList != null)
                {
                    that.chargeLineList = res.data.chargeLineList;
                    that.chargeMoney = that.chargeLineList[0].money;
                }
                if(null != res.data.userCouponList)
                {
                    that.userCouponList = res.data.userCouponList;
                    that.userCouponList.forEach(function(obj,index){
                       if(obj.chargeMoney <= that.chargeMoney*that.num)
                       {
                           that.userCouponId = obj.id;
                       }
                    });
                }
                that.couponList = res.data.couponList == undefined ? [] : res.data.couponList;
                that.onSelectChange();                
            }
            else
            {
                alert(res.data.msg)
                return false;
            }
        })
      },
      paySubmit(){
        let that = this;
        let data = {'bidKey':this.bidKey,'money':this.money,'chargeMoney':this.chargeMoney,'num':this.num,'userCouponId':this.userCouponId}
        this.$ajax({
              method: 'post',
              url: this.GLOBAL.serverSrc + "/person/aliyaysubmit.json",
              data: data,
              headers: {
                  'Content-Type': 'application/json; charset=UTF-8',
                  'token' : this.GLOBAL.token
              }
          }).then(function(res) {
              if(res.data.code == '0000000')
              {
                  that.allMoney = res.data.allMoney;
                  that.couponMoney = res.data.couponMoney;
                  that.payUrl = res.data.payUrl;
                  that.showSubmit();
              }
              else
              {
                  alert(res.data.msg);
                  return false;
              }
          })
      },
      showSubmit(){
            $(".tip1").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip1").fadeOut(200);
            })
      },
      onRadioChange(id, description){
          this.userCouponId = id;
          this.description = description;
      },
      onSelectChange(){
        let that = this;
        let num = 0;
        this.userCouponList.forEach(function(obj,index){
            if(obj.chargeMoney <= that.chargeMoney*that.num)
            {
                that.userCouponId = obj.id;
                that.description = obj.description;
                num = 1;
            }
        });
        if(0 == num)
        {
            this.userCouponId = 0;
            this.description = "无抵用券";
        }
      },
      getCoupon(id){
          let that = this;
        let data = {'id':id}
        this.$ajax({
              method: 'post',
              url: this.GLOBAL.serverSrc + "/person/getcoupon.json",
              data: data,
              headers: {
                  'Content-Type': 'application/json; charset=UTF-8',
                  'token' : this.GLOBAL.token
              }
          }).then(function(res) {
              if(res.data.code == '0000000')
              {
                  that.userCouponList = res.data.userCouponList;
                  that.couponList = res.data.couponList;
              }
              else
              {
                  alert(res.data.msg);
                  return false;
              }
          })
      }
    }
}
</script>
<style>
.title_top1{color: red;font-size: 14px;margin:0px 2px 0px 2px;}
.el-icon-plus:hover{color: rgb(68, 139, 233);}
.el-icon-plus{width:260px;cursor: pointer;font-size:13px;letter-spacing:2px;}
.top_button{letter-spacing:2px;}
.el-radio__input{top:-10px;}
.div-a{ float:left;width:49%;border:1px solid #F00} 
.div-b{ float:left;width:49%;border:1px solid #000} 

.coupon-wrapper{width:100%; height:auto; padding:0 0 2px 0;clear:both;overflow: hidden;}
        .coupon-wrapper .coupon-item{width: 100%;}
        .coupon-wrapper h3{ height: 3rem; line-height: 1.8rem;font-size: 1.4rem; color:#454545; padding: 2% 0;}
        .coupon-item .nick{padding:.66% 0; color: #fff;}
        .coupon-item .coupon-money {width: 100%; display: -webkit-box; display: -webkit-flex; display: flex; font-size: 1.2rem; align-items: center;}
        .coupon-item .coupon-money em{font-size: 3.8rem;}
        .coupon-item .coupon-money .lay:last-child{flex: 1; padding:0 3%;line-height: 1.66rem;}

        .style-four{width: 250px; height:8rem; position: relative;
         display: -webkit-box; display: -webkit-flex; display: flex; align-items: center; justify-content: center;
         background-color: #fff; border:1px solid #E5004F; float: left;}
        .style-four .info-box{-webkit-box: 1; -webkit-flex: 1; flex: 1; padding: 0 1% 0 10%; position: relative;}

        .style-four .get-btn{
            display: -webkit-box; display: -webkit-flex; display: flex; align-items: center; justify-content: center;
            width: 24%; height: 8rem; text-align: center; color: #fff; font-size: 1.5rem; line-height: 1.35; background-color: #E5004F; position: relative;}

        .style-four .nick{color: #000;font-weight: bold;font-size: 16px;}
        .style-four .of, .style-four .lay .tit,
        .style-six .nick{color: #E5004F;font-weight: bold;font-size: 24px;}
        .style-four .lay .demand{color:#000;font-weight: bold;font-size: 18px;}
        .style-four .lay .demand2{color:#000;font-size: 12px;}

        .style-four{background-color: #fff; -webkit-border-radius:1rem; border-radius: 1rem;border: 1px dashed #e5004f;}
        .style-four .get-btn{background-color: #E5004F;width: 30%; height: 8rem; color: #fff; text-align: center;border-top-right-radius: 1rem;border-bottom-right-radius: 1rem;}
        .style-four .get-btn span{ display: block; padding:2.66rem 0; font-size: 1.5rem; word-break: break-all; color: #fff;;}


        /* 已领取 */
        .style-four.have .of, .style-four.have .tit, .style-four.have .demand{color: #c1c1c1;}
        .style-four.have .get-btn span{color: #767676; font-size: 1.6rem;}
        .style-four.have{border: 1px dashed #C1C1C1;}
</style>


// WEBPACK FOOTER //
// src/components/person/chargeaccount.vue